module.exports = __webpack_public_path__ + "img/hero-inst.1c01e98b.jpg";